import { useReadDeal } from '@/api/accounting-dealer'
import { useCompany } from '@/context/companies'
import { formatCurrency, formatPercentage } from '@/helpers'
import { ErrorOutline } from '@mui/icons-material'
import { Box, Card, Skeleton, Stack, styled, Typography } from '@mui/material'

const PlanCard = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2),
  borderRadius: theme.shape.borderRadius,
  background: `linear-gradient(275deg, ${theme.palette.secondary.main} -30%, ${theme.palette.primary.light} 100%)`,
  color: 'white',
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
}))

export function CurrentPlanCard() {
  const { company } = useCompany()

  const { data, isLoading: readingDeal } = useReadDeal(company.deal.key)

  if (readingDeal) {
    return (
      <Skeleton
        variant="rounded"
        height={140}
        sx={{ bgcolor: ['', 'primary.light'] }}
      />
    )
  }

  if (!data) {
    return (
      <Card
        variant="outlined"
        sx={{
          textAlign: 'center',
          gap: 1,
        }}
      >
        <ErrorOutline color="error" fontSize="large" />
        <Typography color="gray">
          Não foi possível carregar os dados do seu plano atual.
        </Typography>
      </Card>
    )
  }

  const plan = data.products.plan.find((plan) => plan.current)

  return (
    <PlanCard>
      <Typography variant="body2">Plano atual</Typography>

      <Box display="flex" alignItems="center" justifyContent="space-between">
        <Typography variant="h3">{plan?.name}</Typography>
        <Typography variant="h3">
          {plan?.price_type === 'fixed' && formatCurrency(plan.price_amount)}
          {plan?.price_type === 'percentage' && (
            <>
              <Typography component="span">Min: </Typography>
              {formatCurrency(plan?.min_price_amount)}
            </>
          )}
        </Typography>
      </Box>

      {plan?.price_type === 'percentage' && (
        <Stack>
          <Typography variant="body2">
            Taxa:{' '}
            {plan.price_rate
              ? `${formatPercentage(plan.price_rate)} do faturamento`
              : '--'}{' '}
          </Typography>
        </Stack>
      )}
    </PlanCard>
  )
}
